import PropTypes from 'prop-types';

import { getSettings } from 'utils/settings';

function Logo({ style, variant }) {
  const companyLogo = getSettings(`logo.${variant}`);

  return (<img
    alt="Company logo"
    src={companyLogo}
    style={style}
  />);
}

Logo.defaultProps = {
  company: 'a55',
  variant: 'imagotipo-horizontal-dark',
};

Logo.propTypes = {
  style: PropTypes.object,
  variant: PropTypes.oneOf([
    'imagotipo',
    'imagotipo-horizontal',
    'imagotipo-horizontal-dark',
  ]),
};

export default Logo;
